import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AngularConfiguration } from 'src/app/core/model/v2/angular-configuration';
import { AngularConfigurationService } from 'src/app/core/services/shared/angular-configuration.service';
import { WindowLoaderService } from 'src/app/shared/components/window-loader/window-loader.service';
import { AppointmentsService } from '../appointments.service';

@Component({
  selector: 'app-appointment-summary',
  templateUrl: './summary.component.html',
  styleUrls: ['./summary.component.scss']
})
export class SummaryComponent implements OnInit, OnDestroy {

  @Input() redirectToAppointments: boolean = false;
  @Input() showHeader: boolean = false;
  timer: any;

  constructor(
    private appointmentsService: AppointmentsService,
    private loaderService: WindowLoaderService,
    private angularConfig: AngularConfigurationService,
    private router: Router) { }

  ngOnInit() {
    this.startTimer();
    this.appointmentsService.restartTimeout$.subscribe(_ => {
      clearInterval(this.timer);
      this.startTimer();
    });
  }

  ngOnDestroy() {
    clearInterval(this.timer);
  }

  private startTimer() {
    this.getSummaryAppointments();
    clearInterval(this.timer);
    this.angularConfig.getConfiguration().subscribe(
      (config: AngularConfiguration) => {
        let reloadTime = config.appointmentsReloadTime * 1000;
        if(!config && (!config.appointmentsReloadTime || config.appointmentsReloadTime <= 0)){
          reloadTime = 60000;
        }
        this.timer = setInterval(() => { this.getSummaryAppointments() }, reloadTime);
      },
      (error)=>{
        console.error(error);
        this.timer = setInterval(() => { this.getSummaryAppointments() }, 60000);
      });
  }

  onRefreshClick(): void {
    this.loaderService.show();
    this.appointmentsService.getCalendarAppointments().subscribe(
      (_) => {
        this.appointmentsService.refreshCalendar.next();
        this.loaderService.hide();
      },
      (error) => {
        console.error(error);
        this.loaderService.hide();
      }
    );
    this.appointmentsService.refreshCalendar.next();
  }

  getSummaryAppointments(): void {
    this.appointmentsService.getSummaryAppointments();
  }

  filterSelection(appointmentType: string): void {
    this.appointmentsService.filterAppointments(appointmentType);
    if (this.redirectToAppointments) {
      localStorage.setItem('appointmentFilterSelected', appointmentType);
      this.router.navigate(['physician/appointments']);
    }
  }

}
